export const ACTIVITY_OFFLINE_CODE = 10003; // 活动已下线
export const ACTIVITY_BLOCKED_CODE = 110002; // 用户风控
export const NOT_VALID_FOR_ACTIVITY = 12001; // 不可参与活动
export const INVALID_CODES = [ACTIVITY_OFFLINE_CODE, ACTIVITY_BLOCKED_CODE, NOT_VALID_FOR_ACTIVITY];
export var API_PATH;
(function (API_PATH) {
    API_PATH["MAIN"] = "/api/altas/marketing/activity/query/info";
    API_PATH["DRAW_PRIZE"] = "/api/altas/marketing/activity/draw/prize";
    API_PATH["QUERY_INTENTION"] = "/api/altas/marketing/query/userTag";
})(API_PATH || (API_PATH = {}));
/**
 * 奖品类型
 */
export var PrizeType;
(function (PrizeType) {
    PrizeType[PrizeType["NEXT_COUPON"] = 1] = "NEXT_COUPON";
    // next券
    PrizeType[PrizeType["GOD_COUPON"] = 2] = "GOD_COUPON";
    // god券
    PrizeType[PrizeType["POINTS"] = 3] = "POINTS";
    // 积分
    PrizeType[PrizeType["MATERIAL_OBJECT"] = 4] = "MATERIAL_OBJECT";
    // 实物
    PrizeType[PrizeType["TOP_COUPON"] = 7] = "TOP_COUPON"; // top券
})(PrizeType || (PrizeType = {}));
/**
 * 金额类型
 */
export var AmountType;
(function (AmountType) {
    AmountType[AmountType["FULL_REDUCTION"] = 1] = "FULL_REDUCTION";
    // 满减
    AmountType[AmountType["DISCOUNT"] = 2] = "DISCOUNT"; // 折扣
})(AmountType || (AmountType = {}));
/**
 * 奖励状态
 */
export var PrizeStatus;
(function (PrizeStatus) {
    PrizeStatus[PrizeStatus["CAN_DRAW"] = 1] = "CAN_DRAW";
    // 可领取
    PrizeStatus[PrizeStatus["CANNOT_DRAW"] = 2] = "CANNOT_DRAW";
    // 不可领取
    PrizeStatus[PrizeStatus["NOT_USED"] = 3] = "NOT_USED";
    // 未使用
    PrizeStatus[PrizeStatus["USED"] = 4] = "USED";
    // 已使用
    PrizeStatus[PrizeStatus["EXPIRED"] = 5] = "EXPIRED";
    // 已过期
    PrizeStatus[PrizeStatus["PRE_DRAW"] = 6] = "PRE_DRAW";
    // 预先领取
    PrizeStatus[PrizeStatus["DRAWN"] = 7] = "DRAWN"; // 已领取
})(PrizeStatus || (PrizeStatus = {}));
/**
 * 不可领券的code
 */
export var CannotDrawCode;
(function (CannotDrawCode) {
    CannotDrawCode[CannotDrawCode["STOCK_SHORTAGE"] = 111001] = "STOCK_SHORTAGE";
    // 库存不足
    CannotDrawCode[CannotDrawCode["NEED_REAL_NAME"] = 111002] = "NEED_REAL_NAME";
    // 需要实名
    CannotDrawCode[CannotDrawCode["NOT_MEET_CONDITIONS"] = 111099] = "NOT_MEET_CONDITIONS"; // 不满足领取条件
})(CannotDrawCode || (CannotDrawCode = {}));
export var LayoutType;
(function (LayoutType) {
    LayoutType["SINGLE"] = "single";
    // 一行一个
    LayoutType["DOUBLE"] = "double";
    // 一行两个
    LayoutType["TRIPLE"] = "triple";
    // 一行三个
    LayoutType["HORIZONTAL"] = "horizontal"; // 横向滚动
})(LayoutType || (LayoutType = {}));
export var ModuleType;
(function (ModuleType) {
    ModuleType[ModuleType["REWARD"] = 6] = "REWARD"; // 领奖模块
})(ModuleType || (ModuleType = {}));
